import Vue from 'vue';
import 
    {
        isMultiEmpresa
    }
from '@/environment';
const palavras = {
    empresa: {
        singular: isMultiEmpresa ? 'Franquia' : 'Empresa',
        plural: isMultiEmpresa ? 'Franquias' : 'Empresas'
    },
    gerente: {
        singular: isMultiEmpresa ? 'Franqueado' : 'Gerente',
        plural: isMultiEmpresa ? 'Franqueados' : 'Gerentes'
    },
    corretora: {
        singular: isMultiEmpresa ? 'Seguradora' : 'Corretora',
        plural: isMultiEmpresa ? 'Seguradoras' : 'Corretoras'
    },
    parceira: {
        singular: isMultiEmpresa ? 'Franquia' : 'Parceira',
        plural: isMultiEmpresa ? 'Franquias' : 'Parceiras'
    }
}

const getPalavra = (palavra = '', minusculo = true, plural = false) => {
    let retorno = palavra;
    if (palavras.hasOwnProperty(palavra)){
        if(plural){
            retorno =  palavras[palavra].plural;
        }else{
            retorno = palavras[palavra].singular;
        }
        if (minusculo){
            return retorno.toLowerCase();
        }
        return retorno;
    }
}
export default getPalavra;


// WEBPACK FOOTER //
// ./src/helpers/language.js